/**
*
* InlineEdit
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Form4 from 'components/interaction/Form4/index.jsx';
import schema from './form.js';
import useInlineEdit from './useInlineEdit.js';
import messages from '../messages.js';

const BodyWrapper = styled.div`
  max-height: calc(100vh - 240px);
  overflow-y: auto;
`;

function InlineEdit(props) {
  const { post, onClose } = props;
  const { defaultValues, handleSubmit, handleChange } = useInlineEdit(post);

  function handleClose() {
    handleChange(null);
    onClose();
  }

  async function handleSubmitClose(data) {
    await handleSubmit(data);
    handleClose();
  }

  return (
    <Form4
      defaultValues={defaultValues}
      schema={schema}
      className="mb-3"
      onCancel={handleClose}
      onSubmit={handleSubmitClose}
      onChange={handleChange}
      submitText={post.id ? messages.save : messages.send}
      navigationWarning
    >
      {({ body, action }) => (
        <>
          <BodyWrapper>
            {body}
          </BodyWrapper>
          {action}
        </>
      )}
    </Form4>
  );
}

InlineEdit.propTypes = {
  post: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

export default InlineEdit;
